$(function () {
  'use strict';

  //////////////////////////////////////////////////////////////////////////////////////
  //
  // V A R I A B L E S
  //
  //////////////////////////////////////////////////////////////////////////////////////

  var $fn = {},
    $el = {
      window       : $(window),
      html         : $('html'),
      body         : $('body'),
      document     : $(document)
    },
    param = {
        winW        : window.innerWidth || $el.window.width(),
        winH        : window.innerHeight || $el.window.height(),
        docW        : $el.document.outerWidth(),
        docH        : $el.document.outerHeight(),
        linkName    : '',
        dataName    : '',
        switch_flg  : '',
        controller  : '',
        photoNumPath : '',
        photoLen : 1,
        photoNum : '',
        flkty   :'',
        scene  : ''




    };
    $fn.mainimgSize = function () {
        var $target = $('.main-carousel');
        var $target_parent = $('.l-main-image');
        var ratio = 1;

        var mainImgW = $('.carousel-cell img').width();
        var mainW = $target_parent.width();

        if ($target_parent.length) {

            if ($target_parent.height() / $target_parent.width() < ratio) {
                $(".main-carousel li.carousel-cell").each(function(index, el) {
                    param.leftPos = '';
                    $('img',this).addClass('vertical');
                    $('img',this).removeClass('horizontal');
                });


            } else {
                mainImgW = mainImgW/2;
                mainW = mainW/2;
                param.leftPos = mainW-mainImgW;
                $(".main-carouse li.carousel-cell").each(function(index, el) {
                    $('img',this).addClass('horizontal');
                    $('img',this).removeClass('vertical');
                });
            }
        }

    };

    /* ************************************************
      * smoothScroll
      *
      * スムーススクロール
      *
     ************************************************* */
    $fn.smoothScroll = function () {
        var headerHight = 98; //ヘッダの高さ
        $('body').on('click', 'a[href^=#]', function () {
            var href= $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top-headerHight;
            $('body,html').animate({scrollTop:position}, 800, 'easeInOutExpo');
            return false;
        });
    };



    /* ************************************************
     * parallaxItem
     *
     * パララックス
     *
    ************************************************* */
    $fn.parallaxItem = function () {
        var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onCenter", duration: "200%"}});

        new ScrollMagic.Scene({triggerElement: "#js-para-about-item01"})
            .on("enter", function () {
                var anim = TweenMax.to("#js-para-about-item01", 1, {ease:Power3.easeOut, opacity:'1'});
            })
            .setTween("#js-para-about-item01", {y: "20%", ease: Linear.easeNone})
            // .addIndicators()
            .addTo(controller);



        new ScrollMagic.Scene({triggerElement: "#js-para-about-item03"})
            .on("enter", function () {
                var anim = TweenMax.to("#js-para-about-item03", 1, {ease:Power3.easeOut, opacity:'1'});
                var anim = TweenMax.to("#js-para-about-item02", 1, {ease:Power3.easeOut, opacity:'1'});

            })
            .setTween("#js-para-about-item03", {y: "-5%", ease: Linear.easeNone})
            // .addIndicators()
            .addTo(controller);


        new ScrollMagic.Scene({triggerElement: "#js-para-about-item04"})
            .on("enter", function () {
                var anim = TweenMax.to("#js-para-about-item04", 1, {ease:Power3.easeOut, opacity:'1'});
                var anim = TweenMax.to("#js-para-about-item05", 1, {ease:Power3.easeOut, opacity:'1'});

            })
            .setTween("#js-para-about-item04", {y: "90%", ease: Linear.easeNone})
            .setTween("#js-para-about-item05", {y: "-60%", ease: Linear.easeNone})
            // .addIndicators()
            .addTo(controller);


        new ScrollMagic.Scene({triggerElement: "#js-para-about-item06"})
            .on("enter", function () {
                var anim = TweenMax.to("#js-para-about-item06", 1, {ease:Power3.easeOut, opacity:'1'});

            })
            .addTo(controller);

        new ScrollMagic.Scene({triggerElement: "#js-para-about-item07"})
            .on("enter", function () {
                var anim = TweenMax.to("#js-para-about-item07", 1, {ease:Power3.easeOut, opacity:'1'});
                var anim = TweenMax.to("#js-para-about-item08", 1, {ease:Power3.easeOut, opacity:'1'});

            })
            .setTween("#js-para-about-item07", {y: "-20%", ease: Linear.easeNone})
            // .addIndicators()
            .addTo(controller);

        new ScrollMagic.Scene({triggerElement: "#js-para-about-item09"})
            .on("enter", function () {
                var anim = TweenMax.to("#js-para-about-item09", 1, {ease:Power3.easeOut, opacity:'1'});

            })
            // .addIndicators()
            .addTo(controller);

        new ScrollMagic.Scene({triggerElement: "#js-para-about-item10"})
            .on("enter", function () {
                var anim = TweenMax.to("#js-para-about-item10", 1, {ease:Power3.easeOut, opacity:'1'});

            })
            .setTween("#js-para-about-item10", {y: "-50%", ease: Linear.easeNone})
            // .addIndicators()
            .addTo(controller);

        new ScrollMagic.Scene({triggerElement: "#js-para-about-item11"})
            .on("enter", function () {
                var anim = TweenMax.to("#js-para-about-item11", 1, {ease:Power3.easeOut, opacity:'1'});
                var anim = TweenMax.to("#js-para-about-item12", 1, {ease:Power3.easeOut, opacity:'1',delay:.4});

            })
            .setTween("#js-para-about-item12", {y: "-50%", ease: Linear.easeNone})
            // .addIndicators()
            .addTo(controller);


    };
    $fn.parallaxItem();






    /* ************************************************
     *
     * map
     *
    ************************************************* */
    $fn.gmap = function() {
        if ($("#map").length) {

            var map = new GMaps({
                el: '#map',
                lat: 34.71880,
                lng: 136.511790,
                panControl: true,
                streetViewControl: false,
                mapTypeControl: false,
                overviewMapControl: false,
                zoomControl: true,
                scrollwheel: false,
            });
            map.addMarker({
                lat: 34.718808,
                lng: 136.511790
            });
            map.addMarker({
                lat: 34.718467,
                lng: 136.512097
            });
            var styles = [
                {
                    stylers: [
                        {hue: "#00ffe6"},
                        {saturation: -20}
                    ]
                }, {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [
                        {lightness: 100},
                        {visibility: "simplified"}
                    ]
                }, {
                    featureType: "road",
                    elementType: "labels",
                    stylers: [
                        {visibility: "off"}
                    ]
                }
            ];

            map.addStyle({
                styledMapName: "Styled Map",
                styles: styles,
                mapTypeId: "map_style"
            });

            map.setStyle("map_style");
        }
    };

    $('.toggle').on('click',function () {
        if( $('body').hasClass('open')){
            $('body').removeClass('open');
        }else{
            $('body').addClass('open');
        }
    });

    $(document).on('click','.l-gallery-content .carousel-cell a ',function () {
        var img = $('img',this).attr('data-image');
        console.log($(this));
        $('#zoom_image img').attr('src',img);
    });
    /* ************************************************
   *
   * intro
   *
  ************************************************* */
    $fn.intro = function() {

        var anim = TweenMax.to("#introBox .blackbg", 1, {ease:Power3.easeOut, y:-(param.winH+120),delay:3,
            onComplete: function(){
                $('#introBox').css('display','none');
                if ($('.main-carousel').length) {
                    param.flkty.playPlayer();
                }
            }
        });
        var anim = TweenMax.to("#introBox .logo img", .5, {ease:Power3.easeOut,  y:'-100px',opacity:'0',delay:3});
        var anim = TweenMax.to(".l-main-image h2.title img", 1, {ease:Power3.easeOut,  y:'0px',opacity:'1',delay:3});
        var anim = TweenMax.to(".l-main-image h2.title div", 1, {ease:Power3.easeOut,  y:'0px',opacity:'1',delay:3});

    }

  //////////////////////////////////////////////////////////////////////////////////////
  //
  // E V E N T
  //
  //////////////////////////////////////////////////////////////////////////////////////



  // common
   $fn.gmap();


    $el.window.resize(function () {
        // $fn.mainimgSize();
    });

});
$(window).on('load',function() {
    var $fn = {},
        $el = {
            window       : $(window),
            html         : $('html'),
            body         : $('body'),
            document     : $(document)
        },
        param = {
            winW        : window.innerWidth || $el.window.width(),
            winH        : window.innerHeight || $el.window.height(),
            docW        : $el.document.outerWidth(),
            docH        : $el.document.outerHeight(),
            linkName    : '',
            dataName    : '',
            switch_flg  : '',
            controller  : '',
            photoNumPath : '',
            photoLen : 1,
            photoNum : '',
            flkty   :'',
            scene  : ''
        };
    $fn.intro = function() {

        var anim = TweenMax.to("#introBox .blackbg", 1, {ease:Power3.easeOut, y:-(param.winH+120),delay:3,
            onComplete: function(){
                $('#introBox').css('display','none');
                if ($('.main-carousel').length) {
                    param.flkty.playPlayer();
                }
            }
        });
        var anim = TweenMax.to("#introBox .logo img", .5, {ease:Power3.easeOut,  y:'-100px',opacity:'0',delay:3});
        var anim = TweenMax.to(".l-main-image h2.title img", 1, {ease:Power3.easeOut,  y:'0px',opacity:'1',delay:3});
        var anim = TweenMax.to(".l-main-image h2.title div", 1, {ease:Power3.easeOut,  y:'0px',opacity:'1',delay:3});

    };

   /* ************************************************
   * indexSlider
   *
   *　indexスライダー
   *
  ************************************************* */

    $fn.mainimgSize = function () {
        var $target = $('.main-carousel');
        var $target_parent = $('.l-main-image');
        var ratio = 1;

        var mainImgW = $('.carousel-cell img').width();
        var mainW = $target_parent.width();

        if ($target_parent.length) {

            if ($target_parent.height() / $target_parent.width() < ratio) {
                $(".main-carousel li.carousel-cell").each(function(index, el) {
                    param.leftPos = '';
                    $('img',this).addClass('vertical');
                    $('img',this).removeClass('horizontal');
                });


            } else {
                mainImgW = mainImgW/2;
                mainW = mainW/2;
                param.leftPos = mainW-mainImgW;
                $(".main-carouse li.carousel-cell").each(function(index, el) {
                    $('img',this).addClass('horizontal');
                    $('img',this).removeClass('vertical');
                });
            }
        }

    };
    $fn.indexSlider = function() {
        if ($('.main-carousel').length) {
            // $fn.mainimgSize();
            var carousel = document.querySelector('.main-carousel');
            param.flkty = new Flickity(carousel, {
                fade: true,
                imagesLoaded: true,
                percentPosition: false,
                autoPlay: 3000,
                friction: .4,
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                pauseAutoPlayOnHover: false,
                draggable: false
            });
            param.flkty.stopPlayer();
        }
    };

    $fn.indexSlider();
    if ($('.main-carousel').length) {
        param.flkty.playPlayer();
    }
});